export default __webpack_public_path__ + "static/media/cl03.40b16df0.jpg";